var errorResponse = '<div class="ajax-error red-text">Oops there appears to have been an error. Please reload your browser and try again.</div>';
var popupContentWrapper;

/**
 * On page load
 **/
$(document).ready( function(){
	var popup = $(document).find('.popup').first();
	popupContentWrapper = $('.popup_content');
	
	if( $(document).find('.popup').length > 0 )
	{
		submitFeedbackForm();
		closePopup();
		/* open upload form Popup */
	    $('.upload-button').click(function() {
	    	if($('.upload-button[data-id]').length == 0) {
				
				$(this).parent().append('<div class="error">Please complete your address details before proceeding.</div>');
			} else {
	        	popup.fadeIn(100);

		        $.ajax({
					url: $(this).data('id'),
					method: 'POST',
					success: function(response) {
						popup.find('.popup_liner').html(response);
						$('body').css('overflow-y','hidden');
					}, 
					error: function(response) {
						alert('There was a problem, please try again');
					}
				});
			}
		});

		/* Applies to all Popups - Close Popup when clicking away */
		
		// $(document).mouseup(function(e) {
		// 	var container = $(".popup_content");

		// 	// If the target of the click isn't the container nor a descendant of the container
		// 	if (!container.is(e.target) && container.has(e.target).length === 0) 
		// 	{
		// 		popup.fadeOut(100);
		// 		popup.find('.popup_liner').html('');
		// 		$('body').css('overflow-y','auto');
		// 	}
		// });
	}
});

$( document ).ajaxComplete(function() {
 	closePopup();
});

function closePopup(){
	/* Applies to all Popups - Close Popup on cross */
	var popup = $(document).find('.popup').first();
    $('.popup_close, .upload_close').on("click", function(){
        popup.fadeOut(100);
       	popup.find('.popup_liner').html('');
       	$('body').css('overflow-y','auto');
	});
}

function loading(isLoading){
    isLoading ? popupContentWrapper.addClass('loading') : popupContentWrapper.removeClass('loading');
}

function AjaxStoryForm(formData, actionURL) {
    loading(true);
    $.ajax({
        url: actionURL,
        type: 'POST',
        data: formData,
        cache: false,
        mimeTypes: 'multipart/form-data',
        processData: false, // Don't process the files
        contentType: false, // Set content type to false as jQuery will tell the server its a query string request
        success: function(response) {
            $('#popupsubmission-contents').html(response);            
            loading(false);
        },
        error: function(response) {
            $('.ajax-destination').html(errorResponse);
            loading(false);
        }
    });
}

// Ajax functionality for the Notice page
function AjaxAction(formData, actionURL) {
    loading(true);
    $.ajax({
        url: actionURL,
        method: 'POST',
        data: formData,
        success: function(response) {
            if(response === 'false'){
                var errorMessage = '<div class="red-text">The provided details don\'t seem to be correct. Please try again.</div>';
                validationArea.html(errorMessage);
            } else{
                $('.ajax-destination').html(response);
                
            }
            loading(false);
        },
        fail: function(response) {
            $('.ajax-destination').html(errorResponse);
            loading(false);
        }
    });
}

function submitFeedbackForm() {
    var files,
        url = $('.popup.forms-popup').data('action-url');
    var popup = $(document).find('.popup').first();

    var fileSizeLimit = (1048576 * 6);
    
    // $('body').on('submit', '#Form_EditSubmissionForm', function(e) {
    //     e.preventDefault();
    //     AjaxAction($(this).serialize(), $(this).attr('action'));
    // });

    // Add events
    $('body').on('change', 'input[type=file]', function(e) {

        //6mb
        if(e.target.files[0]['size'] >= fileSizeLimit){
            $(this).parent().append('<div class="validation_error red-text">That file is too large and will not be used.</div>');
        } else{
            var validationMessage = $(this).parent().find('.validation_error');
            if(validationMessage){
                validationMessage.remove();
            }
            files = e.target.files;
        }

    });

    $('body').on('submit', '#Form_EditSubmissionForm', function(e) {
        e.preventDefault();        

        var data = new FormData();
		$f1 = $('#Form_EditSubmissionForm_SupportingDocuments1');
		$f2 = $('#Form_EditSubmissionForm_SupportingDocuments2');
		$f3 = $('#Form_EditSubmissionForm_SupportingDocuments3');
		$f4 = $('#Form_EditSubmissionForm_SupportingDocuments4');
		$f5 = $('#Form_EditSubmissionForm_SupportingDocuments5');

        //if any of the files are over fileSizeLimit
        if (
            ($f1[0].files.length && $f1[0].files[0].size > fileSizeLimit) ||
            ($f2[0].files.length && $f2[0].files[0].size > fileSizeLimit) ||
            ($f3[0].files.length && $f3[0].files[0].size > fileSizeLimit) ||
            ($f4[0].files.length && $f4[0].files[0].size > fileSizeLimit) ||
            ($f5[0].files.length && $f5[0].files[0].size > fileSizeLimit)
          ) {
            return;
          }


        if($f1.val()) data.append('file1', $f1.get(0).files[0]);
		if($f2.val()) data.append('file2', $f2.get(0).files[0]);
		if($f3.val()) data.append('file3', $f3.get(0).files[0]);
		if($f4.val()) data.append('file4', $f4.get(0).files[0]);
		if($f5.val()) data.append('file5', $f5.get(0).files[0]);

        // Loop over form data and push to FormData object
        $.each($(this).serializeArray(), function(key, value) {
            data.append(value.name, value.value);
        });

        AjaxStoryForm(data, $(this).attr('action'));
    });

    popup.fadeOut(100);
	popup.find('.popup_liner').html('');
	$('body').css('overflow-y','auto');
}